<!--
 * @Description: ''
 * @Author: yangruonan(yangruonan@hztianque.com)
 * @Date: 2021-04-28 09:23:56
 * @LastEditTime: 2021-05-10 09:38:38
-->
<template>
  <div class="hotelManagement">
    <div class="hotel-second-filter">
      <middle-filter @query="query"></middle-filter>
      <div class="filter-box">
        <Button type="primary" @click.stop="addHotel">新增酒店</Button>
      </div>
    </div>
    <div class="hotel-table-tab">
      <loading v-if="showSpin"></loading>
      <s-table
        class="list-table"
        :list="listData"
        :pageSize="pageSizeLeft"
        :total="listLeftTotal"
        :column="columnsLeft"
        :isLoading="false"
        :filterVisible="false"
        :currentPage="currentPageLeft"
        :showPageSize="true"
        @on-page-change="filterListLeft"
        @on-page-size-change="getPageSize"></s-table>
    </div>
    <!-- 酒店 -->
    <hotel-mask
      :show="show"
      :modalTitle="modalTitle"
      :formValidates.sync="formValidate"
      @showModel="closeModal"></hotel-mask>
    <!-- 库存 -->
    <inventory-mask
      :showInventory="showInventory"
      :formValidate="formValidate"
      :id="recordId"
      @showModel="closeModal"></inventory-mask>
    <!-- 线下预约 -->
    <offline-booking-mask
      :showOffline="showOffline"
      :formValidate.sync="formValidate"
      :id="recordId"
      @showModel="closeModal"></offline-booking-mask>
      <!-- 显示/隐藏 -->
      <Modal
      v-model="showOrHide"
      title="提示"
      @on-ok="ok"
      :mask-closable="false"
      @on-cancel="cancel">
      <p>{{modalTitle}}</p>
      <div slot="footer">
        <Button @click="cancel(false)">取消</Button>
        <Button type="primary" @click="ok">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import middleFilter from './components/middle-filter'
import hotelMask from './components/hotel-mask'
import inventoryMask from './components/inventory-mask'
import offlineBookingMask from './components/offline-booking-mask'
import { mapActions } from 'vuex'
export default {
  components: {
    middleFilter,
    hotelMask,
    inventoryMask,
    offlineBookingMask,
  },
  data() {
    return {
      showSpin: false,
      listData: [], //列表数据
      columnsLeft: [], // 表格列的配置描述
      pageSizeLeft: 10, //一页的数量
      listLeftTotal: 1, //总数量
      currentPageLeft: 1, //当前页码
      columnList: [
        {
          title: '酒店id',
          key: 'id',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '酒店名称',
          key: 'hotelName',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '类型',
          key: 'hotelType',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '当前剩余',
          key: 'stock',
          align: 'center',
          checked: true,
        },
        {
          title: '总库存',
          key: 'totalStock',
          align: 'center',
          checked: true,
        },
        {
          key: 'operate',
          title: '操作',
          width: 230,
          align: 'center',
          checked: 'true',
          render: (h, { row }) => {
            return h(
              'div',
              {
                style: {
                  display: 'flex',
                  justifyContent: 'space-around',
                },
              },
              [
                h(
                  'a',
                  {
                    style: {
                      color: row.delFlag === 0 ? '#D3D3D3' : '#2D8cF0',
                    },
                    on: {
                      click: () => {
                        if (row.delFlag === 1) { this.detailsData(row.id) }
                      },
                    },
                  },
                  '编辑',
                ),
                h(
                  'a',
                  {
                    style: {
                      color: row.delFlag === 0 ? '#D3D3D3' : '#2D8cF0',
                    },
                    on: {
                      click: () => {
                        if (row.delFlag === 1) { this.editorInventoryById(row) }
                      },
                    },
                  },
                  '修改库存',
                ),
                h(
                  'a',
                  {
                    style: {
                      color: row.delFlag === 0 ? '#D3D3D3' : '#2D8cF0',
                    },
                    on: {
                      click: () => {
                        if (row.delFlag === 1) { this.offlineBookingById(row) }
                      },
                    },
                  },
                  '线下预约',
                ),
                h(
                  'a',
                  {
                    on: {
                      click: () => {
                        this.toShow(row)
                      },
                    },
                  },
                  row.delFlag === 0 ? '隐藏' : '显示',
                ),
              ],
            )
          },
        },
      ], //列表项
      items: [],
      show: false,
      modalTitle: '',
      formValidate: {},
      formValue: {
        hotelName: '',
        hotelType: '',
      },
      showInventory: false,
      recordId: 0,
      showOffline: false,
      showOrHide: false,
    }
  },
  async created() {
    this.columnsLeft = this.columnList.filter(element => element.checked)
    await this.queryDataList(this.formValue)
  },
  methods: {
    // 获取初始数据列表
    async queryDataList(formValue) {
      const dataObj = {
        pageNo: this.currentPageLeft,
        pageSize: this.pageSizeLeft,
        ...formValue,
      }
      const { dataResult } = await this.getQueryHotelDatalist(dataObj)
      this.listData = dataResult.rows
      this.listLeftTotal = dataResult.total
      this.currentPageLeft = dataResult.page
    },
    // 搜索
    query(val) {
      this.formValue = val
      const dataList = {
        ...this.formValue,
        pageNo: 1,
        pageSize: 10,
      }
      this.queryDataList(dataList)
    },
    // 新增酒店
    async addHotel() {
      this.modalTitle = '新增酒店'
      this.formValidate = {}
      this.show = true
    },
    // 编辑
    async detailsData(id) {
      this.modalTitle = '编辑酒店'
      const res = await this.details({ id: id })
      this.formValidate = res.dataResult
      this.show = true
    },
    // 修改库存
    editorInventoryById(data) {
      this.formValidate = data
      this.recordId = data.id
      this.showInventory = true
    },
    // 线下预约
    offlineBookingById(data) {
      this.recordId = data.id
      this.formValidate = data
      this.showOffline = true
    },
    // 页码改变的回调，返回改变后的页码
    filterListLeft(page = 1) {
      this.currentPageLeft = page
      this.queryDataList(this.formValue)
    },
    // 切换每页条数时的回调，返回切换后的每页条数
    getPageSize(size = 10) {
      this.pageSizeLeft = size
      this.queryDataList(this.formValue)
    },
    // 关闭弹窗
    closeModal(data) {
      this.show = data.flag
      this.showInventory = data.flag
      this.showOffline = data.flag
      if (data.type) { this.queryDataList(this.formValue) }
    },
    toShow(row) {
      this.modalTitle = row.delFlag === 0 ? '确认要隐藏该酒店？' : '确认要显示该酒店？'
      this.formValidate = row
      this.showOrHide = true
    },
    async ok() {
      const res = await this.updateStatus({ id: this.formValidate.id, flag: this.formValidate.delFlag === 0 ? 1 : 0 })
      if (res.code === '0' && res.flag === '0') {
        this.showOrHide = false
        this.$Message.success('操作成功')
        this.queryDataList(this.formValue)
      }
    },
    cancel() {
      this.$Message.info('已取消')
      this.showOrHide = false
    },
    ...mapActions({
      getQueryHotelDatalist: 'jurisprudenceDaily/hotelManagement/getQueryHotelDatalist',
      details: 'jurisprudenceDaily/hotelManagement/details',
      updateStatus: 'jurisprudenceDaily/hotelManagement/updateStatus',
    }),
  },
}
</script>
<style lang="scss" scoped>
.hotelManagement {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  .hotel-second-filter {
    display: flex;
    justify-content: space-between;
  }
  .hotel-table-tab {
    margin-top: 10px;
    height: calc(100% - 32px);
    position: relative;
  }
}
</style>
